/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */
import { Flex, Text } from '@leverege/ui-elements'
import { useMemo } from 'react'
import BondedTableCell from '../components/BondedTableCell'
import { formatPaceTimes } from '../components/Utils'

const TRANSLATED_STAGES = [
  'SW Dry-fit',
  'SW Bonding',
  'SW Cure',
  'Assembly Prep',
  'Assembly Dry-fit',
  'Paste & Close',
  'Inner Laminates & Cure',
  'Demold',
]

const STAGES = [
  'Ajst Seco SW',
  'Unión de SW',
  'Curado de SW',
  'Prep Ensamb',
  'Aj Seco Ensam',
  'Peg. & Cierre',
  'Lam Int & Curado',
  'Desmoldeo',
]

const useBondedTable = ( fgJob, dispatch, delegate ) => {
  const getPercentage = stages => Object.values( stages )?.map( s => `${s?.completionPercentage ?? 0}%` )
  const getTarget = stages => Object.values( stages )?.map( s => formatPaceTimes( s?.targetDuration / 3600 ),
  )
  const getPaces = stages => Object.values( stages )?.map( s => formatPaceTimes( s?.actualDuration / 3600 ),
  )

  const getLastStage = stages => Object.values( stages ).findIndex( s => !!s?.startTime && !s?.endTime )

  const getInProgress = ( stages ) => {
    const lastStage = getLastStage( stages )

    return !( lastStage < 0 )
  }

  const getStartTimes = stages => Object.values( stages ).map( s => s.startTime )
  const getEndTimes = stages => Object.values( stages ).map( s => s.endTime )
  const getTimings = ( startTimes, endTimes ) => startTimes.map( ( st, i ) => [ st, endTimes[i] ] )

  const bndStages = fgJob?.bondedBladeJob?.data?.stage ?? {}

  const data = useMemo(
    () => [
      {
        rowTitle : 'Inspection',
        paces : getPercentage( bndStages ),
        timings : getTimings( getStartTimes( bndStages ), getEndTimes( bndStages ) ),
      },
      {
        rowTitle : 'BND Target',
        paces : getTarget( bndStages ),
      },
      {
        rowTitle : 'BND Actual',
        moldIds : [
          fgJob?.suctionSideJob?.data?.moldHalf?.id,
          fgJob?.pressureSideJob?.data?.moldHalf?.id,
        ],
        stages : bndStages,
        paces : getPaces( bndStages ),
        inProgress : getInProgress( bndStages ),
        timings : getTimings( getStartTimes( bndStages ), getEndTimes( bndStages ) ),
      },
    ],
    [ Object.values( bndStages ).length ],
  )

  const columns = useMemo( () => [
    {
      id : 'Stage',
      Header : <Text variant='columnHeaderCustom'>Stage</Text>,
      sticky : 'left',
      accessor : 'rowTitle',
      Cell : ( { value } ) => (
        <Flex variant='col'>
          <Text variant='columnHeaderCustom'>{value}</Text>
        </Flex>
      ),
      sorted : false,
    },
    ...STAGES.map( ( s, i ) => {
      return {
        id : s + i,
        Header : (
          <Flex
            align='center'
            direction='column'
            gap={4}
            style={{ width : '100%', transform : 'rotate(270deg)' }}>
            <Text variant='columnLabelCustomVertical'>{s}</Text>
            <Text variant='columnSubCustomVertical' style={{ fontSize : 9 }}>
              {TRANSLATED_STAGES[i]}
            </Text>
          </Flex>
        ),
        accessor : item => item.paces[i],
        Cell : props => (
          <BondedTableCell
            index={i}
            {...props}
            dispatch={dispatch}
            delegate={delegate}/>
        )
      }
    } ),
  ], [ data ] )

  return {
    data,
    columns,
  }
}

export default useBondedTable
